<template>
<div id="app" style="height: 100%;">
  <router-view></router-view>
</div>
</template>

<script>
export default{
    components: {
    },
    data: function() {
        return {

        }
    }
}
</script>

<style>
/* 解决table错位 */
body .el-table th.gutter{ display: table-cell!important;}
body .el-table colgroup.gutter{display: table-cell!important;}
</style>



// WEBPACK FOOTER //
// src/App.vue